export const getActivitiesListApi = (query) => {
    const { related_asset_id, ...rest } = query;
    const params = new URLSearchParams();
    Object.entries(rest).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return;
        params.set(key, value);
    });
    let queryString = params.toString();
    if (related_asset_id?.length) {
        const assetParam = `related_asset_id=[${related_asset_id.join(',')}]`;
        queryString = queryString ? `${queryString}&${assetParam}` : assetParam;
    }
    return `/activities/${queryString ? `?${queryString}` : ''}`;
}